import actions from "@/store/modules/organisations/organisation-interview-format-templates/actions";
import {
  mutations,
  state
} from "@/store/modules/organisations/organisation-interview-format-templates/mutations";

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
